'use client'
import { useChapter } from '@/context/ChapterContext'
import {
  Navbar as HNavbar,
  NavbarBrand as HNavbarBrand,
  NavbarContent as HNavbarContent,
  NavbarItem as HNavbarItem,
} from '@heroui/navbar'
import { ChapterMenuButton } from './Chapter'
import NextChapter from './Controls/NextChapter'
import PreviousChapter from './Controls/PreviousChapter'

export default function Navbar() {
  const { currentChapter, currentChapterNumber, totalChapters } = useChapter()

  return (
    <HNavbar
      height={54}
      classNames={{
        base: '!bg-black !sticky !top-0 !left-0 !right-0 !pointer-events-none',
        wrapper:
          '!container !mx-auto !flex !items-center !justify-between !h-[66px] !md:h-[100px] !md:px-0 !pointer-events-auto',
      }}
    >
      <HNavbarBrand>
        <ChapterMenuButton />
      </HNavbarBrand>

      <HNavbarContent className="hidden gap-4 sm:flex" justify="center">
        <HNavbarItem>
          {currentChapter && <span className={'font-bold text-2xl'}>{currentChapter.title}</span>}
        </HNavbarItem>
      </HNavbarContent>

      <HNavbarContent justify="end">
        <HNavbarItem>
          <PreviousChapter />
        </HNavbarItem>

        <HNavbarItem>
          {/* Current chapter */}
          <span>{currentChapterNumber}</span>
        </HNavbarItem>

        <HNavbarItem>
          <span>/</span>
        </HNavbarItem>

        <HNavbarItem>
          {/* Total chapters */}
          <span>{totalChapters}</span>
        </HNavbarItem>

        <HNavbarItem>
          <NextChapter />
        </HNavbarItem>
      </HNavbarContent>
    </HNavbar>
  )
}
